/* -----------------Third parties--------------- */
import { DATE_FORMAT } from "@memorang/constants/date";
import { DateTime } from "luxon";
import { useMemo } from "react";

/* -----------------Local--------------- */
import DateTimePickerModal from "../DateTimePickerModal";

/* -----------------Types--------------- */
type Props = {
	isVisible: boolean;
	onCancel: () => void;
	onConfirm: (date: Date) => void;
	initialDate?: string;
	label?: string;
	saveLabel?: string;
};

/* -----------------Component--------------- */
const DateTimePicker = ({
	isVisible,
	onCancel,
	onConfirm,
	initialDate,
	label = "Test date",
	saveLabel = "Set test date",
}: Props) => {
	const finalMinDate = useMemo(() => {
		if (initialDate) {
			const luxonDate = DateTime.fromFormat(initialDate, DATE_FORMAT);
			if (luxonDate.isValid) {
				return luxonDate.toJSDate();
			}

			const date = new Date(initialDate);
			if (!Number.isNaN(date.getTime())) {
				return date;
			}
		}
		const date = new Date();
		date.setMonth(date.getMonth() + 1);
		return date;
	}, [initialDate]);

	return (
		<DateTimePickerModal
			isVisible={isVisible}
			mode="date"
			onConfirm={onConfirm}
			onCancel={onCancel}
			date={finalMinDate}
			minimumDate={new Date()}
			label={label}
			saveLabel={saveLabel}
		/>
	);
};

export default DateTimePicker;
